module.exports = __webpack_public_path__ + "img/work2.196cb2bc.png";